// frontend/src/components/NotFound.js
import React from "react";
import { Link } from "react-router-dom";
import "../assets/404.css";
import PageContainer from "../pages/PageContainer";

const NotFound = () => {
  return (
    <PageContainer>
      <div className="notfound-container">
        <div className="notfound-background-pattern"></div>

        <div className="notfound-content">
          <h1 className="notfound-error-code">404</h1>

          <h2 className="notfound-title">Page Not Found</h2>

          <div className="notfound-basketball-container">
            <div className="notfound-basketball">
              <div className="notfound-basketball-curve"></div>
              <div className="notfound-basketball-curve"></div>
            </div>
            <div className="notfound-court-line"></div>
          </div>

          <div className="notfound-message">
            <p>
              The URL you're trying to reach might have been relocated, renamed,
              or removed from our system.
            </p>
            <p>
              Let's get you back in the game with the right information and
              tools you need.
            </p>
          </div>

          <div className="notfound-actions">
            <Link to="/home" className="notfound-primary-btn">
              <span className="notfound-icon">🏠</span>
              Return to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default NotFound;
